(() => {
  const initialize = () => document.querySelectorAll('[data-pnm-product]').forEach(root => {
    if (root.dataset.fullGalleryReady) return;
    root.dataset.fullGalleryReady = 'true';
    const dialog = root.querySelector('[data-pnm-media-dialog]');
    const stage = root.querySelector('[data-pnm-media-stage]');
    const templates = [...root.querySelectorAll('[data-pnm-full-media]')];
    if (!dialog || !stage || !templates.length) return;
    const count = root.querySelector('[data-pnm-gallery-count]');
    const touch = window.matchMedia('(pointer: coarse)');
    const tip = root.querySelector('[data-pnm-gallery-tip]');
    const fullTip = root.querySelector('[data-pnm-full-tip]');
    const instruction = (type, full) => type === 'model' ? (full ? (touch.matches ? root.dataset.modelTouch : root.dataset.modelDesktop) : root.dataset.openMedia) : type === 'image' ? (full ? (touch.matches ? root.dataset.fullPhotoTouch : root.dataset.fullPhotoDesktop) : (touch.matches ? root.dataset.photoTouch : root.dataset.photoDesktop)) : root.dataset.openMedia;
    let pageIndex = 0, fullIndex = 0, previousFocus, oldOverflow;
    const wrap = index => (index + templates.length) % templates.length;
    const updateCount = index => { pageIndex = wrap(index); if(count) count.textContent = (pageIndex + 1) + ' / ' + templates.length; if(tip) tip.textContent = instruction(templates[pageIndex].dataset.mediaType, false); };
    const getSlider = () => {
      const $ = window.jQuery;
      return $ && $.fn.slick ? $(root).find('.slider-for.slick-initialized') : null;
    };
    const goTo = index => {
      updateCount(index);
      const slider = getSlider();
      if (slider && slider.length) slider.slick('slickGoTo', pageIndex);
    };
    const bindSlider = () => {
      const $ = window.jQuery;
      if (!$) return;
      $(root).find('.slider-for').off('afterChange.pnmGallery').on('afterChange.pnmGallery', (event, slick, index) => updateCount(index));
    };
    bindSlider();
    window.addEventListener('load', bindSlider, {once:true});
    const showMedia = index => {
      fullIndex = wrap(index);
      stage.querySelectorAll('video').forEach(video => video.pause());
      stage.replaceChildren(templates[fullIndex].content.cloneNode(true));
      stage.dataset.mediaType = templates[fullIndex].dataset.mediaType;
      if (fullTip) fullTip.textContent = instruction(stage.dataset.mediaType, true);
      dialog.querySelectorAll('[data-pnm-full-thumb]').forEach(button => {
        const active = Number(button.dataset.pnmFullThumb) === fullIndex;
        button.setAttribute('aria-pressed', String(active));
        if (active) {
          const strip = button.parentElement;
          if (button.offsetLeft < strip.scrollLeft || button.offsetLeft + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = button.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2;
        }
      });
      dialog.querySelector('[data-pnm-full-count]').textContent = (fullIndex + 1) + ' / ' + templates.length + (templates[fullIndex].dataset.mediaType === 'model' ? ' · 3D' : '');
      if (templates[fullIndex].dataset.mediaType === 'model' && !customElements.get('model-viewer') && window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0'}]);
      }
      goTo(fullIndex);
    };
    const open = index => {
      previousFocus = document.activeElement;
      if (!dialog.open) {oldOverflow = document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow = 'hidden';}
      showMedia(index);
      dialog.querySelector('[data-pnm-media-close]').focus();
    };
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-pnm-gallery-index]');
      if (thumb) {
        event.preventDefault();event.stopPropagation();
        const index = Number(thumb.dataset.pnmGalleryIndex);goTo(index);
        if (thumb.dataset.pnmMediaType === 'model') open(index);
        return;
      }
      const trigger = event.target.closest('[data-pnm-open-media]');
      if (trigger) {event.preventDefault();event.stopPropagation();open(Number(trigger.dataset.pnmOpenMedia));return;}
      const pageStep = event.target.closest('[data-pnm-page-step]');
      if (pageStep) {
        const slider = getSlider();
        const current = slider && slider.length ? slider.slick('slickCurrentSlide') : pageIndex;
        goTo(current + Number(pageStep.dataset.pnmPageStep));
      }
      const fullThumb = event.target.closest('[data-pnm-full-thumb]');
      if (fullThumb) showMedia(Number(fullThumb.dataset.pnmFullThumb));
      const fullStep = event.target.closest('[data-pnm-full-step]');
      if (fullStep) showMedia(fullIndex + Number(fullStep.dataset.pnmFullStep));
      if (event.target.closest('[data-pnm-media-close]')) dialog.close();
    }, true);
    root.addEventListener('keydown', event => {
      const trigger = event.target.closest('[data-pnm-open-media]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {event.preventDefault();open(Number(trigger.dataset.pnmOpenMedia));}
    });
    let swipe = null;
    const pointers = new Set();
    stage.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch') return;
      pointers.add(event.pointerId);
      if (pointers.size !== 1 || stage.dataset.mediaType !== 'image') {swipe = null;return;}
      swipe = {id:event.pointerId,x:event.clientX,y:event.clientY,time:Date.now()};
    });
    stage.addEventListener('pointerup', event => {
      pointers.delete(event.pointerId);
      const start = swipe; swipe = null;
      if (!start || start.id !== event.pointerId || pointers.size || stage.dataset.mediaType !== 'image') return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - start.time < 900) showMedia(fullIndex + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', event => {pointers.delete(event.pointerId);swipe = null;});
    updateCount(0);
    dialog.addEventListener('keydown', event => {
      if (event.target.closest('model-viewer,video,iframe')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();showMedia(fullIndex + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    dialog.addEventListener('close', () => {stage.querySelectorAll('video').forEach(video=>video.pause());stage.replaceChildren();document.documentElement.style.overflow = oldOverflow || '';if(previousFocus && previousFocus.isConnected)previousFocus.focus();});
  });
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
